import React, { useEffect, useState } from 'react';
import './App.css';
import "@mui/material/styles";
import MapComponent from "./MapComponent";
import { UserPreferencesProvider } from './UserPreferencesContext';
import { AuthProvider } from "./authContext";
import { BrowserRouter as Router, Route, Routes, useParams } from 'react-router-dom';
import { ProjectProvider, useProject } from './ProjectContext';
import { FilterProvider } from './FilterContext';
import axios from 'axios';
import config from './config';
import AdminDashboard from "./AdminDashboard";
import ProfilePage from "./ProfilePage/ProfilePage";
import PublicProfilePage from "./ProfilePage/PublicProfilePage";

function LoadProject({ children }) {
    const { city } = useParams();
    const { setProject } = useProject();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // Fetch project details based on URL slug (city)
        axios.post(config.getApiUrl('adminProjectsManager.php'), {
            action: 'get',
            project_url_slug: city || 'default'
        }).then((response) => {
            if (response.data.success && Array.isArray(response.data.projects) && response.data.projects.length > 0) {
                setProject(response.data.projects[0]); // Extract the first project from the array
            } else {
                console.error('Project not found');
            }

            setLoading(false);
        }).catch(error => {
            console.error('Error loading project:', error);
            setLoading(false);
        });
    }, [city, setProject]);

    if (loading) return <div>Loading project...</div>;
    return children;
}

function App() {
    return (
        <AuthProvider>
            <UserPreferencesProvider>
                <ProjectProvider>
                    {/* FilterProvider sits inside ProjectProvider so it can
                        observe project changes (city navigation) and refetch
                        the per-project chip catalogue. Wrapping it here also
                        keeps the same provider instance across route changes
                        on the same project, which preserves filter state when
                        the user toggles in/out of the admin dashboard. */}
                    <FilterProvider>
                        <Router>
                            <div className="App">
                                <Routes>
                                    <Route path="/admin" element={<AdminDashboard />} />
                                    {/* /profile is mounted OUTSIDE LoadProject because it is
                                        a per-user page that has no project context — the
                                        wireframe shows account-level settings only. */}
                                    <Route path="/profile" element={<ProfilePage />} />
                                    {/* PR #48: /u/:userId is the public, read-only
                                        contributor profile opened from the Contributors
                                        directory. Anonymous-friendly (getPublicProfile.php
                                        scrubs PII), so no project context required. */}
                                    <Route path="/u/:userId" element={<PublicProfilePage />} />
                                    <Route path="/:city" element={<LoadProject><MapComponent /></LoadProject>} />
                                    <Route path="/" element={<LoadProject><MapComponent /></LoadProject>} />
                                </Routes>
                            </div>
                        </Router>
                    </FilterProvider>
                </ProjectProvider>
            </UserPreferencesProvider>
        </AuthProvider>
    );
}

export default App;
